/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Impersonation_BannerInputs */

const vi_impersonation_banner = /** @type {(inputs: Impersonation_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang xem với tư cách ${i?.name} — chế độ chỉ xem`)
};

/**

* @param {Impersonation_BannerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const impersonation_banner = /** @type {((inputs: Impersonation_BannerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_BannerInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_impersonation_banner(inputs)
});